module.exports = __webpack_public_path__ + "7e4b29ba/img/archive-icon.0a6a9de3.svg";